/* eslint-disable import/prefer-default-export */

import {
  RELOAD_REQUESTED
} from '../constants/postedPostsConstants';

const axios = require('axios').default;
import { toast } from 'react-toastify';

export const reloadRequested = () => ({
  type: RELOAD_REQUESTED
});

export const deletePost = (dispatch, csrfToken, team, post) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete("/teams/" + team.id + "/posts/" + post.id)
      .then(({ data }) => {
        dispatch(reloadRequested());
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};
